import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { SENDER_USER } from "ui/filter";
import { ConnectedFullDeviceListTable } from "ui/full-device-list/connected-full-device-list-table";
import { NavLoader } from "ui/loader";
import { QsParamController } from "ui/qs-param-controller";
import { ConnectedWsDeviceStatusConnStatus } from "ui/ws-ds-conn-status/connected-ws-ds-conn-status";
import { Page } from "view/layout/page";

class TagViewV2Page extends React.PureComponent {
  static get propTypes() {
    return {
      devices: PropTypes.object,
      history: PropTypes.object.isRequired,
      location: PropTypes.object.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      tag: PropTypes.object,
      user: PropTypes.object,
    };
  }

  constructor(props) {
    super(props);

    this.onFilterStateChange = this.onFilterStateChange.bind(this);
    this.renderView = this.renderView.bind(this);
  }

  onFilterStateChange(filterApi, filterState) {
    const { history, location } = this.props;
    const { pathname } = location;

    if (filterState.sender === SENDER_USER) {
      const qString = filterApi.serializeFilters(filterState);

      history.push({ pathname, search: qString });
    }
  }

  deviceFilter(tag, device) {
    return device.tags.find((t) => t.id === tag.id);
  }

  renderView() {
    const { history, location, storesLoaded, tag } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    if (!tag) {
      return <Redirect to="/404" />;
    }

    return (
      <div>
        <Row>
          <Col xs={12}>
            <ConnectedWsDeviceStatusConnStatus />
          </Col>
        </Row>
        <QsParamController
          location={location}
          qsName="order_by"
          qsValue="status,id"
          noOverride
          onMount
        >
          <QsParamController
            location={location}
            qsName="tags"
            qsValue={String(tag.id)}
            multi
          >
            <ConnectedFullDeviceListTable
              history={history}
              location={location}
              onStateChange={this.onFilterStateChange}
              search
            />
          </QsParamController>
        </QsParamController>
      </div>
    );
  }

  render() {
    const { tag } = this.props;
    const title = tag ? `Devices tagged as ${tag.name}` : "Devices (Tag)";
    const view = this.renderView();

    return <Page title={title}>{view}</Page>;
  }
}

export { TagViewV2Page };
